export class ContractStatus {
    id = null;

    description = '';
}
